import React from 'react';
import { ICheckFilter } from './interfaces';
import { CheckboxGroupField } from '../../../forms';

export const CheckFilter: React.FC<ICheckFilter> = ({
  label,
  onChange,
  value,
  options,
}): JSX.Element => {
  return (
    <CheckboxGroupField
      options={options}
      value={value}
      label={label}
      onChange={onChange}
    />
  );
};
